import React, { useEffect, useState } from "react";
import CustomdropDown from "./customdropDown";
import axios from "axios";
import { Grid } from "@mui/material";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../hooks/snackBar/reducers";

const City = ({ formik, cityId }) => {
  const dispatch = useDispatch()
  const [cityList, setCityList] = useState([]);
  
  const getCityList = (id) => {
    axios
      .post("/v1/cities", { state_id: id })
      .then((res) => {
        setCityList(res.data);
        _.filter(res.data, val=>val.id===cityId).map(val=>formik.setFieldValue('city',val))
      })
      .catch((err) =>{
        dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
      });
  };
  useEffect(() => {
    if (formik.values.state) {
      getCityList(formik.values.state.id)
    } else {
      setCityList([])
      formik.setFieldValue("city", null)
    }
  }, [formik.values.state]);
  return (
    <Grid>
      <CustomdropDown
        id="city"
        data={cityList}
        optionLabel={(option) => option.name}
        value={formik.values.city}
        onchange={(e, value) => {
          formik.setFieldValue("city", value);
        }}
        optionEqual={(option, value) => option.name === value.name}
        placeholder="Select city"
        helperText={formik.touched.city && formik.errors.city}
        errorMsg={formik.touched.city && Boolean(formik.errors.country)}
        title="City *"
      />
    </Grid>
  );
};

export default City;
